import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
import { useAppConfig } from '../../AppConfigProvider';
import logo from '../../images/Docusync-logo.svg';

export default function Login({ uId, setUId, fetchMe }) {
    const appConfig = useAppConfig();
    const [username, setUserName] = useState();
    const [password, setPassword] = useState();
    const navigate = useNavigate();
    const handleSubmit = async e => {
        e.preventDefault();
        const u_details = {
            "username": username,
            "password": password
        }
        await loginUser(u_details);
    }

    async function loginUser(credentials) {
        return axios.post(appConfig.backendUrl + 'api/v1/auth', credentials)
            .then(function (response) {
                // localStorage usage removed as per user request
                // setUId mapping handled by fetchMe/session state in App
                toast.success("Logged In Successfully", {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                fetchMe(); // Refresh session state
                setTimeout(function () {
                    navigate('/');
                }, 800);

            })
            .catch((error) => {
                console.error(error);
                let errorMessage = "An error occurred during login";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.response && error.response.status === 401) {
                    errorMessage = "Error: Invalid username or password";
                } else {
                    errorMessage = error.code || error.message || errorMessage;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            });
    }

    return (<>
        <div className='login-page d-flex align-items-center justify-content-center min-vh-100'>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-5 col-md-7 col-sm-9 col-11">
                        <div className="card shadow-lg border-0 rounded-4 my-2 my-md-4">
                            <div className="card-body p-4 p-md-4">
                                <div className="text-center mb-3">
                                    <img src={logo} alt="logo" className='logo-img img-fluid mb-2' style={{ maxWidth: '100px' }} />
                                    <h2 className="fw-bold fs-3" style={{ color: '#2c3e50' }}>Welcome Back!</h2>
                                    <p className="text-muted small">Sign in to continue</p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <input type="text" className="form-control btn-radius btn-input py-2" id="username" placeholder="Email" onChange={e => setUserName(e.target.value)} />
                                    </div>
                                    <div className="mb-3">
                                        <input type="password" className="form-control btn-radius btn-input py-2" id="password" placeholder="Password" onChange={e => setPassword(e.target.value)} />
                                    </div>
                                    <div className="mb-3 text-end">
                                        <Link to="/forgot-password" size='sm' className='links forgot-password-btn text-decoration-none' style={{ fontSize: '0.85rem' }}>Forgot Password?</Link>
                                    </div>
                                    <div className="mb-3">
                                        <button className='signin-btn w-100 py-2 shadow-sm fw-bold' style={{ transition: 'all 0.3s' }} type="submit">Sign In</button>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <p className="mb-0 text-muted" style={{ fontSize: '0.95rem' }}>Don't have an account? &nbsp;</p>
                                        <Link className='links text-decoration-none' to='/register'><b>Sign Up</b></Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    </>
    )
}

